<div class="select-box rounded-lg custom-bg-select-box" [ngClass]="addCustomClass ? addCustomClass : ''"
appClickedOutside
(clickedOutside)="handleClickedOutside()"
>
  <div class="select-box-header p-3 flex items-center "
  [ngClass]="expandir_contraer && addBackground ? addBackground :  expandir_contraer && !addBackground ? 'border-b-1 border-bottom-color' : ''"
  (click)="abrirCerrar()"
  >
    <span class="select-box-label w-11/12 flex gap-2 items-center">
      <ng-container *ngIf="value">
        <ion-icon *ngIf="addFilterIcon" name="funnel" class="text-base leading-4 text-primary"></ion-icon>
        <mat-icon *ngIf="addAlertIcon" class="mdi mdi-alert text-base leading-4 color-custom-red" ></mat-icon>
        {{ value }}
      </ng-container>
      <!-- si no llega el value -->
      <ng-content select="[selectedCustomLabel]"></ng-content>
    </span>
    <ion-icon [src]="expandir_contraer  ? 'assets/icon/up-arrow.svg' : 'assets/icon/down-arrow.svg' "
    class="text-lgmax self-center w-1/12"></ion-icon>
  </div>
  <div class="transition duration-300 overflow-y-auto max-h-0 scrollbar "
  [ngClass]="expandir_contraer && !optionsContainerHeight ? 'max-h-[9.5rem] sm:max-h-40 lg:max-h-50' :
  expandir_contraer && optionsContainerHeight ? optionsContainerHeight : ''"
  >
    <ng-content select="[selectOptions]"></ng-content>
  </div>
</div>
